import React from "react";
import PolicyLayout from "./policyLayout";
import Seo from "components/Seo";

const TermsConditions = () => {
    return (
        <React.Fragment>
            <Seo type="" pageTitle="표준약관" />
            <PolicyLayout>
                <div className="bg-[#f4f4f4] flex flex-col items-center justify-center pb-16 pt-5 responsive1200:pt-0 responsive1200:px-[4%]">
                    <p className="py-[35px] text-[#333] text-[28px] font-[600] responsive1200:py-[30px] responsive1200:text-[24px]">
                        표준약관
                    </p>
                    <div className="bg-white px-[4%] py-[50px] max-w-[1200px] mx-auto">
                        <div className="border border-[#dddddd] p-[15px] text-[#666666] text-[14px]">
                            <p>제1장총칙</p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                제1조[목적]
                            </p>
                            <p>이약관은배송사업자택배서비스와고객간의배송거래를위하여그계약조건을정함을목적으로한다</p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                제2조[용어의정의]
                            </p>
                            <p>
                                1."배송"이라함은소형/소량의배송물을고객의주택,사무실또는기타의장소에서수탁하여수하인의주택,사무실또는기타의장소까지배송하여인도하는것을말한다.
                            </p>
                            <p>2."배송사업자"(이하사업자라한다)라함은배송을영업으로하는자를말한다.</p>
                            <p>3."고객"이라함은배송사업자에게배송을위탁하는자로서의뢰인(고객)을말한다.</p>
                            <p>4."수하인"이라함은고객이배송장에배송물의수령자로지정하여기재하는자를말한다.</p>
                            <p>5."배송장"이라함은사업자와고객간의배송계약의성립과내용을증명하기위하여사업자가교부한문서를말한다.</p>
                            <p>6."수탁"이라함은배송사업자가배송을위하여고객으로부터배송물을수령하는것을말한다.</p>
                            <p>7."인도"라함은사업자가수하인에게배송장에기재된운송물을넘겨주는것을말한다.</p>
                            <p>
                                8."손해배상한도액"이라함은운송물의멸실,훼손에사업자가손해를배상할수있는최고한도액을말한다.다만,"손해배상한도액"은고객이운송장에운송물의가액을기재하지아니한경우에한하여적용되며사업자는그금액을미리이약관의별표로제시한다.
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                제3조[약관의명시및설명]
                            </p>
                            <p>사업자는이약관을사업장및홈페이지,카페등공식적인자리에게시한다.</p>
                            <p>1.사업자는계약을체결하는때에고객에게다음각호의사항을설명한다.</p>
                            <p>2.고객이배송물의물품가액을기재한경우사업자의손해배상시그가액이손해배상액의산정기준이된다는사항.</p>
                            <p>3.고객이배송물의가액을기재하지않은면사업자의손해배상시손해배상한도액내에서만손해배상을한다는사항</p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                제4조[적용법규등]
                            </p>
                            <p>이약관에규정되지않은사항에대하여서는상법등의법규와공정한일반관습에따른다</p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                제5조[운임의청구와유치권]
                            </p>
                            <p>
                                1.사업자는배송물을수탁할때고객에게운임을청구할수있다.다만,고객과의합의에따라배송물을인도할때수하인에게청구할수있다.
                            </p>
                            <p>2.제1항단서의경우수하인이운임을지급하지않을경우사업자는배송물을유치할수있다.</p>
                            <p>3.배송물이50만원을초과하거나배송상특별한중의를요하는경우에는사업자는따로추가요금을청구할수있다.</p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                *배송물가액*
                            </p>
                            <p>50만원~100만원:정상운임+요금의50%적용</p>
                            <p>100만원~200만원:정상운임+요금의80%적용</p>
                            <p>200만원~300만원:정상운임+요금의100%적용</p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                제6조[배송장또는영수증의교부의무]
                            </p>
                            <p>
                                사업자는다음각호의내용이기재된배송장또는영수증을계약체결시에교부하여야한다.단,1호의경우배송장이외에별도로기재할수있다.
                            </p>
                            <p>1.고객및수하인의상호,주소,전화번호.</p>
                            <p>2.사업자의상호,주소,전화번호.</p>
                            <p>3.배송자의이름.</p>
                            <p>4.배송물의종류및가액.</p>
                            <p>5.배송비용.</p>
                            <p>6.배송물의인도예상시간.</p>
                            <p>7.손해배상한도액(50)만원</p>
                            <p>*고객이배송장에배송물의가액을기재하지아니하면사업자가손해배상을할경우이한도액이적용됨.</p>
                            <p>8.기타배송에관하여필요한사항.</p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                제7조[포장]
                            </p>
                            <p>1.고객은배송물을그성질,중량,용적등에따라배송에적합하도록포장하여야한다.</p>
                            <p>
                                2.사업자는배송물의포장이배송에적합하지아니한때에는고객에게필요한포장을하도록요구하거나고객의승락을얻어고객의부담으로필요한포장을할수있다.
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                제8조[배송물의확인]
                            </p>
                            <p>1.사업자는신고된배송물의종류와수량에관하여고객의동의를얻어그참여하에이를확인할수있다.</p>
                            <p>
                                2.사업자가제1항의규정에의하여배송물을확인한경우에배송물의종류와수량이같은때에는사업자가그로인하여발생한비용또는손해를부담하며다를때에는고객이이를부담한다.
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                제9조[배송물의배송거절및면책사항]
                            </p>
                            <p>사업자는다음각호의경우에배송물의배송을거절할수있다.</p>
                            <p>1.배송에적합한포장이되지않은경우.</p>
                            <p>2.고객이배송물확인을거절하거나배송물의종류와수량이다른경우.</p>
                            <p>3.배송물포장의크기가가로30cm*세로40cm*높이30cm를초과하는경우.</p>
                            <p>4.배송물의무게가30kg을초과하는경우.</p>
                            <p>5.배송물의가액이300만원을초과하는경우.</p>
                            <p>6.배송물의인도예정시간에따른배송이불가능한경우.</p>
                            <p>7.배송물이화약류,인화물질등위험한물건인경우.</p>
                            <p>8.배송물이밀수품,군수품.부정산임산물등위법한물건인경우.</p>
                            <p>9.배송물이현금,카드,어음,수표.유가증권등현금화가가능한물건인경우.</p>
                            <p>10.배송물이살아있는동물또는동물사체등인경우.</p>
                            <p>11.배송물이볍령,사회질서기타선량한풍속에반하는경우.</p>
                            <p>12.배송이천재지변기타불가항력적인사유로불가능한경우.</p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                제10조[배송지연에대한배상]
                            </p>
                            <p>
                                배송물이인도예정시간의50%이상초과하여수취인에게인도될때에는사업자는고객에게배송비용의50%에해당되는금액을환급하여야한다.다만,고객의귀책사유로인하여수취인의주소및연락처등기타배송물의인도장소를사업자및배송자가정확히알수없던때에는그러하지아니한다.
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>제2장배송물의인도</p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                제11조[공동배송또는타배송수단의이용]
                            </p>
                            <p>
                                사업자는고객의이익을해치지않은범위내에서수탁한배송물을다를배송사업자와협정을체결하여공동으로배송하거나배송수단을이용하여배송할수있다.
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                제12조[수하인부재시및수취거부]
                            </p>
                            <p>
                                1.사업자는배송물의인도시수하인으로부터인도확인을받아야하며,수하인의대리인에게배송물을인도하였을경우에는수하인에게그사실을통지한다.
                            </p>
                            <p>
                                2.사업자는수하인의부재로인하여배송물을인도할수없을경우에는수하인에게배송물을인도하고자한일시,사업자의명칭,문의할전화번호,기타배송물의인도에필요한사항을기재해서면(부재중방문표)으로통지한후사업소에배송물을보관할수있다.
                            </p>
                            <p>
                                3.수하인이인도거부시사업자는송하인에게통지한후(휴대폰문자포함)송하인이물건을돌려받고자할시편도요금의70%더적용되며수하인이인도예정시간으로부터24시간이상운송물을수령하지아니할경우수하인또는송하인은인도예정일을초과한일수에보관료가적용되며보관료(1일1만원)에따른비용으로부담하여야하며송하인과수하인에게최종통보후운송물을7일이내찾아가지않을경우임의처분한다.
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>제3장배송물의사고</p>
                            <p>
                                <br />
                                제13조[사고발생시조치]
                            </p>
                            <p>사업자는배송물의수탁후부터인도전까지파손등을발견할때에는지체없이그사실을고객에게통지한다.</p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>제4장사업자의책임</p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                제14조[인도할수없는배송물의처분]
                            </p>
                            <p>
                                1.사업자는수하인을확인할수없거나(수하인불명),수하인이배송물의수령을거절하거나(수령거절),수령할수없은경우(수령불능)에는해당배송물을고객에게환송한다.
                            </p>
                            <p>2.제1항의규정에따라배송물이환송되는경우사업자는이에소요되는비용은고객의부담으로한다.</p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                제15조[고객의처분청구권]
                            </p>
                            <p>1.고객은사업자에대하여배송의중지,배송물의반환,기타의처분을청구할수있다.</p>
                            <p>
                                2.사업자는제1항의규정에의한고객의청구가있는때에는공동배송또는배송수단의이용등으로인해배송상현저한지장이발생할우려가있는경우를재외하고는이에응한다.이경우이미배송한비율에따라운임과배송물의처분에소요되는비용은고객의부담으로한다.
                            </p>
                            <p>3.제1항의규정에의한고객의청구권은수하인에게배송물을인도한때에는소멸한다.</p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                제16조[책임의시작]
                            </p>
                            <p>배송물의멸실,훼손또는연착에관한사업자의책임은배송물을고객으로부터수탁한때로부터시작한다.</p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                제17조[공동배송또는타배송수단이용시책임]
                            </p>
                            <p>
                                사업자가다른배송사업자와협정을체결하여공동으로배송하거나다른배송사업자의배송수단을이용하여배송한배송물이멸실,훼손또는연착되는때에는이에대한책임은사업자가부담한다.
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                제18조[손해배상]
                            </p>
                            <p>
                                1.고객이배송장에배송물의가액을기재하면사업자의손해배상시그가액이손해배상의산정기준액이되며기재하지않으면"손해배상한도액"내에서손해배상한다.
                            </p>
                            <p>
                                2.배송물에일부멸실또는훼손에대한사업장의책임은수하인이배송물을수령한날로부터7일이내에그사실을사업자에게통보하지않으면소멸된다.
                            </p>
                            <p>
                                3.사업자는물품이전부또는일부멸실된때에는배송장에기재한물품가액범위내에서손해배상을하고물품가액을기재하지않은경우에는인도일의인도장소에서운송물가액을기준으로산정한손해액을배상한다.
                            </p>
                            <p>
                                4.퀵서비스는1개당300만원을초과하는물품은취급하지않는다.50만원을초과하는물품에대해서는할증운임이적용된경우에한하여기재한뭄품가액범위내에서손해배상을하고물품가액을기재하지않은경우에는손해배상한도액(50만원)범위내에서배상한다.
                            </p>
                            <p>5.귀중품은신고가액에따라차등할증을적용한다.(제5조3항에해당한다)</p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                제19조[사고발생시운임등의환급과청구]
                            </p>
                            <p>
                                1.배송물의멸실,현저한훼손,연착이천재지변기타불가항력적인사유또는고객의책임없는사유로인한것인때사업자가이미운임이나비용을받은때에는이를환급한다.
                            </p>
                            <p>
                                2.배송물의멸실,현저한훼손또는연착이배송물의성질이나하자또는고객의과실로인한것인때에는사업자는운임의전액을비롯하여배송물의처분등에소요되는비용을청구할수있다.
                            </p>
                            <p>
                                <br />
                            </p>
                            <p>
                                <br />
                                제20조[면책사항]
                            </p>
                            <p>
                                사업자는천재지변기타불가항력적인사항에의하여발생한배송물의멸실,훼손또는연착에대해서는손해배상책임을지지아니한다.
                                <br />
                                <br />
                            </p>
                        </div>
                    </div>
                </div>
            </PolicyLayout>
        </React.Fragment>
    );
};

export default TermsConditions;
